export function fixImageUrl(src: string): string
export function fixImageUrl(src: string | undefined): string | undefined
export function fixImageUrl(src: string | undefined): string | undefined {
  if (!src) return src
  try {
    const url = new URL(src)
    if (url.host === 'dresscode-stage.s3.eu-central-1.amazonaws.com') {
      url.host = 'imgs-stage.dresscode.ai'
    }
    if (url.host === 'dresscode-stage-2.s3.eu-central-1.amazonaws.com') {
      url.host = 'imgs-stage.dresscode.ai'
    }
    if (url.host === 'dresscode-prod.s3.eu-central-1.amazonaws.com') {
      url.host = 'imgs.dresscode.ai'
    }
    if (url.host === 'dresscode-prod-2.s3.eu-central-1.amazonaws.com') {
      url.host = 'imgs.dresscode.ai'
    }
    if (url.host === 'mosaica-upload.s3.eu-central-1.amazonaws.com') {
      url.host = 'imgs-ai.dresscode.ai'
    }
    if (url.host === 'mosaica-upload-2.s3.eu-central-1.amazonaws.com') {
      url.host = 'imgs-ai.dresscode.ai'
    }
    if (url.host === 'imgs.atelierdigital.ai' || url.host === 'imgs.apiresq.com') {
      url.host = 'imgs.dresscode.ai'
    }
    const atelier = ['.atelierdigital.ai', '.apiresq.com'].find(d => location.host.endsWith(d))
    if (atelier && url.host === 'imgs.dresscode.ai') {
      url.host = 'imgs' + atelier
    }
    const showoff = location.host.endsWith('.showoff.app')
    if (showoff && url.host === 'imgs.dresscode.ai') {
      url.host = 'imgs.showoff.app'
    }
    return url.toString()
  } catch {
    return src
  }
}
